import React from "react";

function NotFound() {
    return (
        <div style={{ textAlign: "center", padding: "100px 20px", color: "#ffffff",}}>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <h4>The page you are looking for does not exist.</h4>
        </div>
    );
}

export default NotFound;